// extracted by mini-css-extract-plugin
export default {"header":"Header_header__d+igc","header_1":"Header_header_1__SRrjr","header_2":"Header_header_2__R85kw"};